<template>
  <v-menu
    offset-y
    left
    transition="slide-y-transition"
    v-if="$store && $store.state.app.closed_day"
    :close-on-content-click="false"
    v-model="menuOpen"
    attach
  >
    <template #activator="{ on, value }">
      <v-btn
        text
        :icon="$vuetify.breakpoint.smAndDown"
        v-on="on"
        :input-value="value"
        :class="{'btn-40': $vuetify.breakpoint.smAndDown}"
      >
        <span
          class="text-truncate d-md-inline d-sm-none"
          style="max-width: 200px"
          :class="[$vuetify.rtl ? 'mr-1' : 'ml-1']"
          v-if="$store.state.app.closed_day.working_date"
          v-show="$vuetify.breakpoint.mdAndUp"
        >{{ $store.state.app.closed_day.working_date | formatDate("DD MMM YYYY") }}</span>
        <span
          class="text-truncate d-md-inline d-sm-none"
          style="max-width: 200px; color: #999; font-style: italic;"
          :class="[$vuetify.rtl ? 'mr-1' : 'ml-1']"
          v-show="$vuetify.breakpoint.mdAndUp"
          v-else-if="isLoading"
        >
          Loading...
        </span>
        <span
          class="text-truncate d-md-inline d-sm-none"
          style="max-width: 200px"
          :class="[$vuetify.rtl ? 'mr-1' : 'ml-1']"
          v-show="$vuetify.breakpoint.mdAndUp"
          v-else
        >
          Closed
        </span>
        <v-icon
          v-if="showArrow"
          right
          class="d-md-inline d-sm-none"
        >
          mdi-chevron-down
        </v-icon>
        <v-btn
          icon
          class="d-sm-inline d-md-none"
          :small="$vuetify.breakpoint.smAndDown"
        >
          <v-icon>mdi-calendar-range</v-icon>
        </v-btn>
      </v-btn>
    </template>
    <!-- <v-list dense nav>
      <v-list-item
      >
        <v-list-item-title>Opened at {{ $store.state.app.closed_day.open_date | formatDate("DD MMM YYYY HH:mm:ss") }} by {{ $store.state.app.closed_day.open_by_name }}</v-list-item-title>
      </v-list-item>
    </v-list> -->
    <!-- style="position: relative; top: 40%; left: 45%" -->
    <v-card>
      <v-card-text class="text-center">
        <span
          class="text-truncate d-sm-inline d-md-none"
          v-if="$store.state.app.closed_day.working_date"
        >
          Working Date:
          {{ $store.state.app.closed_day.working_date | formatDate("DD MMM YYYY") }}
        </span>
        <span
          class="text-truncate d-sm-inline d-md-none"
          v-else-if="isLoading"
          style="color: #999; font-style: italic;"
        >
          Loading...
        </span>
        <SwitchButton />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import qs from "query-string";
import SwitchButton from "@/pages/working_days/switch/SwitchButton.vue";

export default {
  components: {
    SwitchButton
  },
  data() {
    return {
      menuOpen: false
    };
  },
  props: {
    showArrow: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
  },
  computed: {
    ...mapState("app", ["openToolbarMenu"]),
    isLoading() {
      const hasOutlet = this.$route.query.outletId && this.$route.query.hotelId;
      const hasWorkingDate = this.$store.state.app.closed_day?.working_date;
      const hasLastClosedDay = this.$store.state.app.last_closed_day?.working_date;

      // HIERARCHICAL LOADING: Replicate ToolbarHotels' isLoadingHotel logic
      const selectedChainId = this.$store.state.app.selectedHotelChainId;

      if (selectedChainId !== null) {
        // Find selectedHotel the same way ToolbarHotels does
        const hotels = this.$store.state.app.hotels || [];
        let selectedHotel = {};

        if (hotels && hotels.length > 0) {
          const hotelIdFromQuery = this.$route.query.hotelId;
          // Find default Hotel
          selectedHotel = hotels.find((i) => i.default_hotel);
          if (selectedHotel == null || typeof selectedHotel == "undefined"){
            selectedHotel = hotels[0];
          }
          if (hotelIdFromQuery) {
            selectedHotel = hotels.find((i) => i.id == hotelIdFromQuery);
          }
        }

        // Check if hotel is in transition (same check as ToolbarHotels)
        if (selectedHotel && selectedHotel.id) {
          if (selectedHotel.hotel_chain_id !== selectedChainId) {
            // Hotel is loading, so working day should also show loading
            return true;
          }
        }
      }

      // Check if outlet is in transition (hotel changed but no outlets loaded yet)
      const hotelId = parseInt(this.$route.query.hotelId);
      if (hotelId) {
        const outlets = this.$store.state.app.outlets || [];
        const hotelsOutlets = outlets.filter(o => o.hotel_id === hotelId);
        if (hotelsOutlets.length === 0 && outlets.length >= 0) {
          // Outlets are loading, so working day should also show loading
          return true;
        }
      }

      // If we have an outlet but no working_date and no last_closed_day, we're loading
      return hasOutlet && !hasWorkingDate && !hasLastClosedDay;
    }
  },
  methods: {
    ...mapMutations("app", ["setOpenToolbarMenu"])
  },
  watch: {
    openToolbarMenu(newMenu) {
      // Close this menu if another menu opens
      if (newMenu && newMenu !== "closedDay") {
        this.menuOpen = false;
      }
    },
    menuOpen(isOpen) {
      // Update store when this menu opens/closes
      if (isOpen) {
        this.setOpenToolbarMenu("closedDay");
      } else if (this.openToolbarMenu === "closedDay") {
        this.setOpenToolbarMenu(null);
      }
    }
  }
};
</script>
